/* inlinePlayerWrapper-compiled.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./inlinePlayerWrapper-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { getDimensionsWithDefault } from '../utils/lightCards/getDimensionsWithDefault';
import { VcMediaWrapperProps } from '@atlaskit/react-ufo/vc-media';
import UFOCustomData from '@atlaskit/react-ufo/custom-data';
var hideNativeBrowserTextSelectionStyles = null;
var selectedBorderStyle = null;

/*
 * Used to display the blue border around a selected card without
 * shrinking the image OR growing the card size
 */
var borderStyle = null;
export var inlinePlayerClassName = 'media-card-inline-player';
export var LOCAL_WIDTH_VARIABLE = '--media-inline-player-wrapper-width';
export var LOCAL_HEIGHT_VARIABLE = '--media-inline-player-wrapper-height';
var inlinePlayerWrapperStyles = null;

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

export var InlinePlayerWrapper = function InlinePlayerWrapper(props) {
  var testId = props.testId,
    selected = props.selected,
    dimensions = props.dimensions,
    onClick = props.onClick,
    innerRef = props.innerRef;
  return /*#__PURE__*/React.createElement("div", _extends({
    id: "inlinePlayerWrapper",
    "data-testid": testId
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: ax(["_1reo15vq _18m915vq _2rkofajl _kqswh2mm _p12f1osq _c71l1osq _1bsb1ez3 _4t3i1amq _1y2k1osq _z18o1osq", selected && "_1p1y1j28 _1rk81j28 _14r11j28 _1np21j28", "_14mjfajl _aetrb3bt _z0ai1osq _1qdg1osq _18postnw _15l2idpf _631ousvi _11fnglyw", selected && "_eq43fyzg", inlinePlayerClassName]),
    onClick: onClick,
    ref: innerRef
  }, VcMediaWrapperProps, {
    style: _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, LOCAL_WIDTH_VARIABLE, getDimensionsWithDefault(dimensions).width || '100%'), LOCAL_HEIGHT_VARIABLE, getDimensionsWithDefault(dimensions).height || 'auto'), "--_og9e1j", ix("var(".concat(LOCAL_WIDTH_VARIABLE, ")"))), "--_1wtike8", ix("var(".concat(LOCAL_HEIGHT_VARIABLE, ")")))
  }), /*#__PURE__*/React.createElement(UFOCustomData, {
    data: {
      hasMediaComponent: true
    }
  }), props.children);
};